
import { z } from "zod";

// Custom validation for URLs that allows both full URLs and relative paths
const urlOrRelativePathSchema = z.string().optional().refine(
  (value) => {
    if (!value || value === "") return true;
    
    // Allow relative paths (starting with / or ./ or ../)
    if (value.startsWith("/") || value.startsWith("./") || value.startsWith("../")) {
      return true;
    }
    
    // Allow full URLs
    try {
      new URL(value);
      return true;
    } catch {
      return false;
    }
  },
  {
    message: "Must be a valid URL or relative path"
  }
).or(z.literal(""));

// Create a more flexible string validation that accepts any string value
// This allows for legacy data while still providing validation
const flexibleStringSchema = z.string().optional().or(z.literal(""));

export const characterFormSchema = z.object({
  name: z.string().min(1, "Name is required"),
  slug: z.string().min(1, "Slug is required").regex(/^[a-z0-9-]+$/, "Slug must contain only lowercase letters, numbers, and hyphens"),
  description: z.string().optional(),
  personality: z.string().optional(),
  // Use flexible validation for dropdown fields to support both predefined and custom values
  species: flexibleStringSchema,
  role: flexibleStringSchema,
  age_group: flexibleStringSchema,
  color_theme: flexibleStringSchema,
  image_url: urlOrRelativePathSchema,
  avatar_url: urlOrRelativePathSchema,
  status: z.enum(["draft", "published", "archived"]),
  display_order: z.number().min(0),
  featured: z.boolean(),
  teaching_focus: z.string().optional(),
  special_talents: z.string().optional(),
});

export type CharacterFormData = z.infer<typeof characterFormSchema>;
